export const MAX_APPROVAL_TITLE_LENGTH = 100;
export const MAX_APPROVAL_NOTE_LENGTH = 1000;